import { computed } from 'vue'
import type { TableItems } from '@/types/component/common/table/commonTable'
import type { UploadTableRow } from '@/types/aeroUpload/aeroUpload'
import { useAeroUploadStore } from '@/stores/aeroUploadStore'
import { storeToRefs } from 'pinia'
import { UploadStatusLabel } from '@/constants/ui/aeroUpload/uploadStatus'
import { format } from 'date-fns'

export const useUploadStatusTable = () => {
  const uploadStore = useAeroUploadStore()
  const { uploadFileList } = storeToRefs(uploadStore)

  const itemsTyped = computed<TableItems<Partial<UploadTableRow>>>(() =>
    // ストアからテーブル表示用データに変換
    uploadFileList.value.map(data => ({
      fileName: data.fileName,
      status: data.status,
      statusLabel: UploadStatusLabel?.[data.status]?.replace('{0}', data.progress.toFixed(0)) ?? '',
      completedDateTime: data.completedDateTime
        ? format(data.completedDateTime, 'yyyy-MM-dd HH:mm:ss')
        : '-'
    }))
  )

  return { itemsTyped }
}
